import React from 'react';
import { Outlet, Route } from 'react-router';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import EventsSearchPageRoute from './EventsSearchPageRoute';

const basePath = '/v2/events';

export default (
  <Route
    path={basePath}
    element={
      <MainLayout>
        <Outlet />
      </MainLayout>
    }
  >
    <Route index element={<EventsSearchPageRoute />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
